import * as React from 'react';
import {forwardRef, useEffect, useRef} from 'react';
import {getTypeName} from 'features/services/utils/name-helpers';

import {Tag} from "features/search/types";
import {Button, ButtonColor, ButtonSize, ButtonType} from '@atoms/LinksAndButtons/Button';
import {markFirstWordInSentence} from "@organisms/ResidenceSearch/Search/helpers";
import classnames from "classnames";

interface Props {
    tag: Tag;
    searchString: string;
    onClick: (tag: Tag) => void;
    active?: boolean;
    tabIndex?: number;
}

export const TagMenuItem = forwardRef<HTMLButtonElement, Props>(({tag, searchString, onClick, active}, _ref) => {
    const _item = useRef<HTMLSpanElement>(null);
    const itemBtn = useRef<HTMLButtonElement>(null);

    const internalOnClick = () => {
        onClick(tag)
    };

    useEffect(() => {
        if(active && itemBtn.current !== null) {
            itemBtn.current.scrollIntoView({ block: 'nearest' });

            if(document.activeElement !== null && document.activeElement.className === 'search-field__input') return;

            itemBtn.current.focus();
        }
    }, [active]);

    const getParentTagName = (): React.ReactNode | null => {
        let parentTagName = '';

        switch (tag.type) {
            case "county":
                break;
            case "municipality":
                parentTagName = tag.county ? `, ${tag.county.displayName ?? tag.county.name} ${getTypeName("county")}` : '';
                break;
            case "stage":
            case "area":
                parentTagName = tag.municipality ? `, ${tag.municipality.displayName ?? tag.municipality.name} ${getTypeName("municipality")}` : '';
                break;
        }

        if (!parentTagName) return null;

        return <strong> {parentTagName}</strong>;
    };

    let tagName = tag.displayName ? tag.displayName : tag.name;
    tagName = tagName && tagName.charAt(0).toUpperCase() + tagName.substring(1);

    const value = markFirstWordInSentence(searchString, tagName, tag.type);

    if(!value) return null;

    const classes = classnames('tag-menu-item', {
        'tag-menu-item--active': active,
    });

    return (
        <Button 
            className={classes}
            onClick={internalOnClick}
            ref={itemBtn}
            buttonColor={ButtonColor.UNSET} 
            buttonSize={ButtonSize.DEFAULT} 
            buttonType={ButtonType.NO_STYLE} 
        >
            <span className="tag-menu-item__name notranslate">{value}</span>
            <span className="tag-menu-item__parent-name notranslate">{getParentTagName()}</span>
        </Button>
    );
});
